import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { TopMenu } from "../../shared";

function ContactUs() {
  return (
    <>
      <TopMenu />
      <Col lg={12} className='inner-bg'>
        <Container className="middle-content">
          <div className="page-heading">
            <img src='https://pmfby.amnex.co.in/pmfby/lms/lms-inner-banner.jpg' alt='Inner Banner - LMS' className='img-fluid pb-4' />
            <h4 className="fw-bold mb-2">Contact Us</h4>
            <ul className="my-topbreadcrum">
              <li>
                <a
                  href="/lms"

                >Home</a>
              </li>
              &nbsp; / &nbsp;
              <li>Contact Us</li>
            </ul>
          </div>
          <div>
            <p>
              This website belongs to Department of Agriculture and Farmers Welfare,
              Ministry of Agriculture and Farmers Welfare, Government of India.
            </p>
            <p className="mbtm0">
              <strong>Address</strong>
            </p>
            <p>
              Department of Agriculture & Farmers Welfare, <br />MoA & FW,
              <br />
              Krishi Bhawan,

              Dr Rajendra Prasad Road,
              <br />
              New Delhi - 110001
            </p>
          </div>
        </Container>
      </Col>
    </>
  );
}

export default ContactUs;
